import {ValueObject} from '@s-ui/domain'

export class NewsPostCommentRequestValueObject extends ValueObject {
  /**
   * @param {Object} params
   * @param {String} params.articleId
   * @param {String} params.userId
   * @param {String} params.comment
   * @param {String} params.commentId
   * @param {Object} params.token
   */
}
